export default "__VITE_ASSET__6ohoO_VW__"